import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FiDragScrollDirective } from './fi-drag-scroll.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [FiDragScrollDirective],
    exports: [FiDragScrollDirective],
})
export class FiDragScrollModule {}
